module.exports = __webpack_public_path__ + "img/background_principal_pc1210.638db08f.webp";